import { defineMessages } from '@transcend-io/internationalization';

export const downloadZipButtonMessages = defineMessages(
  'ad-core-components.DownloadZipButton.downloadZipButton',
  {
    download: {
      defaultMessage: 'Download Report',
    },
    downloadTooltip: {
      defaultMessage:
        'Downloads the report that the data subject can view from the Privacy ' +
        'Center. Customizations such as datapoint configurations, file counts, ' +
        'redactions, and omissions are applied to this report.',
    },
    saving: {
      defaultMessage: 'Downloading files to disk...',
    },
    downloaded: {
      defaultMessage: 'Downloaded to disk!',
    },
    downloadAllFiles: {
      defaultMessage: 'Download Admin Report',
    },
    downloadAllFilesTooltip: {
      defaultMessage:
        'Downloads a full administrator-level report with all files in their ' +
        'original, unmodified state. Customizations such as datapoint ' +
        'configurations, file counts, redactions, and omissions are not applied ' +
        'to this report.',
    },
  },
);
